import { DatePicker } from '@material-ui/pickers';
import React, { useState } from 'react';
import { DateCell } from '../../../utils/Cells';
import { useStyles } from '../styles/Styles';
import { ClearIcon } from "@material-ui/icons/Clear";

export default function ErrorAwareDatePicker(props) {

    const classes = useStyles(props, "date")();
    const helperText = () => {
        if (props.errors && props.errors.has(props.name)) {
            return props.errors.get(props.name).huText;
        } else if (props.prevValue && props.value && props.value.getTime() !== new Date(props.prevValue).getTime()) {
            return <DateCell value={new Date(props.prevValue)} />;
        } else {
            return "";
        }
    }

    const isError = () => {
        if (props.errors) {
            return props.errors.has(props.name);
        } else {
            return false;
        }
    }

    const handleClear = (e) => {
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
        props.onChange(null);
    };

    const { prevValue, ...rest } = props;
    return (
        <DatePicker
            autoOk
            fullWidth
            error={isError()}
            helperText={helperText()}
            variant="inline"
            inputVariant="outlined"
            format="yyyy.MM.dd"
            className={classes.root}
            FormHelperTextProps={{ className: "helper-text" }}
            clearable="true"
            {...rest}
            InputProps={{
                endAdornment: (
                    props.value && <div
                        style={{ marginRight: 20, cursor: "pointer" }}
                    >
                        <button className="close-modal-btn lnr-cross"
                            onClick={handleClear}
                        ></button>
                    </div>
                )
            }}
        />
    )

};